import HomeAction from 'home/actions/HomeAction'
import { differenceBy, intersectionBy, isUndefined, maxBy, orderBy } from 'lodash'
import PropTypes from 'prop-types'
import React, { useEffect, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import Card from '../../../../components/card/Card'
import ProgressCard from '../../../../components/card/ProgressCard'
import Select from '../../../../components/forms/Select'
import QualityAction from '../../../../quality/actions/QualityAction'
import { DELETE, INSERT, UPDATE } from '../../../../utils/constants/ActionConstants'
import { getSetting } from '../../../../utils/SettingUtils'
import { getLabel } from '../../../../utils/StoreUtils'
import AdministrationAction from '../../../actions/AdministrationAction'
import { THRESHOLD_FULL } from '../../../constants/AdministrationConstants'
import { Grid2 } from '@mui/material'
import useBoolean from 'utils/customHook/useBoolean'
import useTitle from 'utils/customHook/useTitle'
import ParameterAction from 'referencial/components/parameter/actions/ParameterAction'
import UnitAction from 'referencial/components/unit/actions/UnitAction'
import { StyledFieldSet } from 'components/StyledElements'
import useActions from 'utils/customHook/useActions'
import { PopinImportThresholds, StepperThreshold, Threshold } from './ComponentsOptionThreshold'
import ConfirmModal from 'components/modal/ConfirmModal'
import WaitAction from 'wait/WaitAction'
import TaxonAction from 'referencial/components/taxon/actions/TaxonAction'
import UserAction from 'administration/components/user/actions/UserAction'
import ReferencialAction from 'referencial/action/ReferencialAction'
import useStateAppSetting from 'utils/customHook/useStateAppSetting'
import useSandreList from 'utils/customHook/useSandreList'
import FractionAction from 'referencial/components/fraction/actions/FractionAction'
import { EXPORT_IMPORT_THRESHOLD_HEADERS, THRESHOLD, THRESHOLD_DISCRIMINANT, THRESHOLD_DISPLAY, THRESHOLD_TYPE, THRESHOLD_TYPE_CODE } from 'utils/QualityThresholdUtils'

const ListThresholds = ({
    thresholds = [],
    setThresholds = () => {},
    qualityThresholds = [],
    setQualityThresholds = () => {},
    isEditMode = false,
}) => {
    const {
        value: isOpen,
        setTrue: open,
        setFalse: close,
    } = useBoolean(false)
    const {
        value: isConfirmOpen,
        setTrue: openConfirm,
        setFalse: closeConfirm,
    } = useBoolean(false)

    const [selectedCode, setSelectedCode] = useState()

    const thresholdsFormatted = useMemo(() => {
        const parentsThresholds = thresholds.filter(th => isUndefined(th.referenceCode))
        const formatThreshold = th => {
            const qualityThreshold = qualityThresholds.find(qt => qt.thresholdCode === th.code)
            const childrens = thresholds.filter(child => child.referenceCode === `${th.code}`)
            return {
                threshold: th,
                childrens: childrens.map(formatThreshold),
                qualityThreshold,
            }
        }
        return parentsThresholds.map(formatThreshold)
    }, [qualityThresholds, thresholds])

    const selectedThreshold = useMemo(() => {
        return thresholds.find(th => th.code === selectedCode)
    }, [selectedCode, thresholds])

    const selectedQualityThreshold = useMemo(() => {
        return qualityThresholds.find(qt => qt.thresholdCode === selectedCode)
    }, [qualityThresholds, selectedCode])

    return (
        <>
            {
                thresholdsFormatted.map(({ threshold, childrens, qualityThreshold }) => {
                    return (
                        <Threshold
                            threshold={threshold}
                            qualityThreshold={qualityThreshold}
                            childrenThresholds={childrens}
                            isEditMode={isEditMode}

                            toogleActive={code => {
                                setThresholds(prev => prev.map(th => th.code === code ? { ...th, status: th.status === 1 ? 0 : 1, isUpdated: true } : th))
                            }}
                            onUpdate={code => {
                                setSelectedCode(code)
                                open()
                            }}
                            onDelete={code => {
                                setSelectedCode(code)
                                openConfirm()
                            }}
                            setQualityThresholds={(thresholdCode, newQualityThresholds) => {
                                setThresholds(prev => prev.map(th => th.code === thresholdCode ? { ...th, isUpdated: true } : th))
                                setQualityThresholds(prev => {
                                    return prev.map(qt => {
                                        if (qt.thresholdCode === thresholdCode) {
                                            return {
                                                ...qt,
                                                thresholds: newQualityThresholds,
                                            }
                                        }
                                        return qt
                                    })
                                })
                            }}

                            key={threshold.code}
                        />
                    )
                })
            }
            <StepperThreshold
                isOpen={isOpen}
                onClose={close}
                onSave={(threshold, qualityThreshold) => {
                    setThresholds(prev => prev.map(th => th.code === threshold.code ? { ...threshold, isUpdated: true } : th))
                    setQualityThresholds(prev => prev.map(qt => qt.thresholdCode === threshold.code ? qualityThreshold : qt))
                    close()
                }}

                selectedThreshold={selectedThreshold}
                selectedQualityThreshold={selectedQualityThreshold}
            />
            <ConfirmModal
                isOpen={isConfirmOpen}
                title={i18n.deletingConfirmation}
                onValidate={() => {
                    setQualityThresholds(prev => prev.filter(qt => qt.thresholdCode !== selectedCode))
                    setThresholds(prev => prev.filter(th => th.code !== selectedCode))
                    closeConfirm()
                }}
                onClose={closeConfirm}
            />
        </>
    )
}

ListThresholds.propTypes = {
    thresholds: PropTypes.arrayOf(PropTypes.shape({
        code: PropTypes.number,
        name: PropTypes.string,
        comment: PropTypes.string,
        status: PropTypes.number,
    })),
    setThresholds: PropTypes.func,
    qualityThresholds: PropTypes.arrayOf(PropTypes.shape({
        thresholdCode: PropTypes.number,
        thresholdType: PropTypes.string,
        thresholds: PropTypes.arrayOf(PropTypes.shape({
            parameterCode: PropTypes.string,
            unit: PropTypes.string,
            station: PropTypes.number,
            fraction: PropTypes.string,
            threshold1: PropTypes.number,
            threshold2: PropTypes.number,
            threshold3: PropTypes.number,
            threshold4: PropTypes.number,
        })),
    })),
    setQualityThresholds: PropTypes.func,
    isEditMode: PropTypes.bool,
}

const QualityThresholdApp = ({

}) => {
    const dispatch = useDispatch()
    const {
        applicationSettings,
        thresholdsProps,
        qualityThresholdsProps,
        parameters,
        taxons,
        units,
        fractions,
        qualitometers,
    } = useSelector(store => ({
        applicationSettings: store.AdministrationReducer.applicationSettings,
        thresholdsProps: store.QualityReducer.thresholds,
        qualityThresholdsProps: store.QualityReducer.qualityThresholds,
        parameters: store.ParameterReducer.parameters,
        taxons: store.TaxonReducer.taxons,
        units: store.UnitReducer.units,
        fractions: store.FractionReducer.fractions,
        qualitometers: store.QualityReducer.qualitometersLight,
    }), shallowEqual)

    const lexiconCalcium = useSandreList('CALCIUM')
    const lexiconFRType = useSandreList('QUALITOMETRES.TYPE_FR.RIVIERE')
    const lexiconFishContext = useSandreList('QUALITOMETRES.CONTEXTEPISCICOLE')

    const [thresholdPC, setThresholdPC] = useStateAppSetting('SEUILS')
    const [thresholdTaxon, setThresholdTaxon] = useStateAppSetting('SEUILS.TAXONS')
    const [thresholdState, setThresholdState] = useStateAppSetting('SEUILS.ETATS')

    useTitle(() => [{
        title: i18n.quality,
        href: '/quality',
    }, {
        title: i18n.qualityOptions,
        href: '/quality/qualityOptions',
    }, {
        title: i18n.thresholds,
        href: '/quality/qualityOptions/threshold',
    }], [])

    const {
        value: isEditMode,
        setTrue: editMode,
        setFalse: readMode,
    } = useBoolean(false)
    const {
        value: isOpen,
        setTrue: open,
        setFalse: close,
    } = useBoolean(false)
    const {
        value: isImportOpen,
        setTrue: openImport,
        setFalse: closeImport,
    } = useBoolean(false)

    const [thresholds, setThresholds] = useState([])
    const [qualityThresholds, setQualityThresholds] = useState([])

    const [progress, setProgress] = useState(0)
    const {
        value: isLoaded,
        setTrue: loaded,
    } = useBoolean(false)

    useEffect(() => {
        dispatch(HomeAction.setHelpLink('qualite', '62'))
        dispatch(ParameterAction.fetchParameters())
        dispatch(TaxonAction.fetchTaxons())
        dispatch(UnitAction.fetchUnits())
        dispatch(FractionAction.fetchFractions())
        dispatch(ReferencialAction.fetchSandreCodes())
        dispatch(QualityAction.fetchQualitometersLight())
        dispatch(QualityAction.fetchAllThresholds(setProgress)).then(result => {
            setThresholds(result.thresholds)
            setQualityThresholds(result.qualityThresholds)
            loaded()
        })
        dispatch(UserAction.fetchApplicativeUsers())
    }, [])

    const orderedThresholds = useMemo(() => {
        return orderBy(thresholds, 'name')
    }, [thresholds])

    const thresholdPCList = useMemo(() => orderedThresholds.filter(t => t.thresholdType === THRESHOLD.PC), [orderedThresholds])
    const thresholdTaxonList = useMemo(() => orderedThresholds.filter(t => t.thresholdType === THRESHOLD.TAXON), [orderedThresholds])
    const thresholdStateList = useMemo(() => orderedThresholds.filter(t => t.thresholdType === THRESHOLD.STATE), [orderedThresholds])

    const onExport = () => {
        const THRESHOLD_TYPE_LABEL = {
            [THRESHOLD_TYPE.INCREASING]: i18n.increasing,
            [THRESHOLD_TYPE.DECREASING]: i18n.decreasing,
            [THRESHOLD_TYPE.BOUNDED]: i18n.bounded,
        }
        const THRESHOLD_DISPLAY_LABEL = {
            [THRESHOLD_DISPLAY.INCREASING]: i18n.increasing,
            [THRESHOLD_DISPLAY.DECREASING]: i18n.decreasing,
        }
        const DISCRIMINANT_SIGN = {
            [THRESHOLD_DISCRIMINANT.SUP_OR_EQUAL]: '>=',
            [THRESHOLD_DISCRIMINANT.STRICTLY_SUP]: '>',
            [THRESHOLD_DISCRIMINANT.INF_OR_EQUAL]: '<=',
            [THRESHOLD_DISCRIMINANT.STRICTLY_INF]: '<',
            [THRESHOLD_DISCRIMINANT.INF_OR_SUP_OR_EQUAL]: '<= =>',
            [THRESHOLD_DISCRIMINANT.STRICTLY_INF_OR_SUP]: '< >',
        }

        const data = orderedThresholds.flatMap(threshold => {
            const qualityThreshold = qualityThresholds.find(qt => qt.thresholdCode === threshold.code)
            if (isUndefined(qualityThreshold)) {
                return [{
                    code: threshold.code,
                    name: threshold.name,
                    comment: threshold.comment,
                    parent: getLabel(thresholds, threshold.referenceCode),
                }]
            }
            const listReferencial = [THRESHOLD.PC, THRESHOLD.INDICE].includes(threshold.thresholdType) ? parameters : taxons
            return qualityThreshold.thresholds.map(t => {
                const qualitometer = qualitometers.find(q => q.id === t.station)
                return {
                    thresholdCode: threshold.name,
                    thresholdName: threshold.comment,
                    type: THRESHOLD_TYPE_CODE[threshold.thresholdType],
                    codeParameterOrTaxon: t.parameterCode,
                    parameterOrTaxon: listReferencial.find(r => r.code === t.parameterCode)?.name,
                    codeUnit: t.unit,
                    unit: units.find(u => u.code === t.unit)?.symbolWithName,
                    stationCode: qualitometer?.code,
                    station: qualitometer?.name,
                    fractionCode: t.fraction,
                    fraction: fractions.find(f => f.id === t.fraction)?.name,
                    thresholdType: THRESHOLD_TYPE_LABEL[t.thresholdType],
                    displayMode: THRESHOLD_DISPLAY_LABEL[t.display],
                    discriminant: DISCRIMINANT_SIGN[t.discriminant],
                    threshold1: t.threshold1,
                    threshold2: t.threshold2,
                    threshold3: t.threshold3,
                    threshold4: t.threshold4,
                    hardnessCode: t.calciumClass,
                    hardness: lexiconCalcium.find(l => l.code === t.calciumClass)?.name,
                    frTypeCode: t.frType,
                    frType: lexiconFRType.find(l => l.code === t.frType)?.name,
                    fishContextCode: t.fishCode,
                    fishContext: lexiconFishContext.find(l => l.code === t.fishCode)?.name,
                    parent: getLabel(thresholds, threshold.referenceCode),
                }
            })
        })
        return {
            data: data.length ? [
                { ...data[0], headers: EXPORT_IMPORT_THRESHOLD_HEADERS.map(h => h.key ?? h) },
                ...data.slice(1),
            ] : data,
            exportType: 'xlsx',
            titleFile: i18n.thresholds,
        }
    }

    useActions(() => {
        if (isEditMode) {
            return {
                new: open,
                cancel: () => {
                    readMode()
                    setThresholds(thresholdsProps)
                    setQualityThresholds(qualityThresholdsProps)
                },
                import: openImport,
                save: () => {
                    dispatch(WaitAction.waitStart())
                    const thresholdPCFound = thresholds.find(t => t.code === thresholdPC)
                    const thresholdTaxonFound = thresholds.find(t => t.code === thresholdTaxon)
                    const thresholdStateFound = thresholds.find(t => t.code === thresholdState)
                    const newSettings = [
                        { parameter: 'SEUILS', value: !isUndefined(thresholdPCFound) && thresholdPCFound.status !== 0 ? `${thresholdPC}` : '' },
                        { parameter: 'SEUILS.TAXONS', value: !isUndefined(thresholdTaxonFound) && thresholdTaxonFound.status !== 0 ? `${thresholdTaxon}` : '' },
                        { parameter: 'SEUILS.ETATS', value: !isUndefined(thresholdStateFound) && thresholdStateFound.status !== 0 ? `${thresholdState}` : '' },
                    ].filter(p => getSetting(applicationSettings, p.parameter) !== p.value)
                    if (newSettings.length) {
                        dispatch(AdministrationAction.updateSieauParameters(newSettings))
                    }

                    const thresholdsCreated = differenceBy(thresholds, thresholdsProps, 'code').map(th => {
                        return {
                            dataType: THRESHOLD_FULL,
                            updateType: INSERT,
                            thresholdFullInput: {
                                threshold: th,
                                parameterThresholds: qualityThresholds.find(qt => qt.thresholdCode === th.code)?.thresholds.map(t => ({ ...t, listType: th.thresholdType })),
                            },
                        }
                    })
                    const thresholdsDeleted = differenceBy(thresholdsProps, thresholds, 'code').map(th => {
                        return {
                            dataType: THRESHOLD_FULL,
                            updateType: DELETE,
                            thresholdFullInput: {
                                threshold: th,
                                parameterThresholds: [],
                            },
                        }
                    })
                    const thresholdsUpdated = intersectionBy(thresholds, thresholdsProps, 'code').filter(t => t.isUpdated).map(th => {
                        return {
                            dataType: THRESHOLD_FULL,
                            updateType: UPDATE,
                            thresholdFullInput: {
                                threshold: th,
                                parameterThresholds: qualityThresholds.find(qt => qt.thresholdCode === th.code)?.thresholds.map(t => ({ ...t, thresholdCode: th.code, listType: th.thresholdType })),
                            },
                        }
                    })

                    const updateActions = [...thresholdsCreated, ...thresholdsDeleted, ...thresholdsUpdated]

                    dispatch(QualityAction.updateThresholds(updateActions))
                        .then((res = { update: 0 }) => {
                            readMode()
                            if (res.update === 0) {
                                dispatch(WaitAction.waitStop())
                                return
                            }
                            dispatch(QualityAction.fetchAllThresholds())
                                .then(result => {
                                    setThresholds(result.thresholds)
                                    setQualityThresholds(result.qualityThresholds)
                                })
                                .finally(() => dispatch(WaitAction.waitStop()))
                        })
                },
            }
        }
        return {
            edit: editMode,
            export: onExport,
        }
    }, [isEditMode, thresholds, qualityThresholds, qualitometers, thresholdPC, thresholdTaxon, thresholdState, lexiconCalcium, lexiconFRType, lexiconFishContext])

    return (
        <div style={{ maxWidth: '1200px', marginLeft: 'auto', marginRight: 'auto', paddingBottom: '100px' }}>
            {
                !isLoaded && (
                    <ProgressCard progress={progress} />
                )
            }
            {
                isLoaded && (
                    <Grid2 container spacing={1}>
                        <Grid2 size={12}>
                            <StyledFieldSet>
                                <Grid2 container spacing={1} sx={{ paddingTop: '5px' }}>
                                    <Grid2 size={12}>
                                        <Select
                                            label={i18n.defaultThresholdPC}
                                            options={thresholdPCList}
                                            onChange={setThresholdPC}
                                            value={thresholdPC}
                                            nullLabel='&nbsp;'
                                            withThresholdGroups
                                            disabled={!isEditMode}
                                            active={isEditMode}
                                        />
                                    </Grid2>
                                    <Grid2 size={12}>
                                        <Select
                                            label={i18n.defaultThresholdTaxon}
                                            options={thresholdTaxonList}
                                            onChange={setThresholdTaxon}
                                            value={thresholdTaxon}
                                            nullLabel='&nbsp;'
                                            withThresholdGroups
                                            disabled={!isEditMode}
                                            active={isEditMode}
                                        />
                                    </Grid2>
                                    <Grid2 size={12}>
                                        <Select
                                            label={i18n.defaultThresholdState}
                                            options={thresholdStateList}
                                            onChange={setThresholdState}
                                            value={thresholdState}
                                            nullLabel='&nbsp;'
                                            withThresholdGroups
                                            disabled={!isEditMode}
                                            active={isEditMode}
                                        />
                                    </Grid2>
                                </Grid2>
                            </StyledFieldSet>
                        </Grid2>
                        {
                            !thresholds.length && (
                                <Grid2 size={12}>
                                    <Card><h5 className='padding-1'>{i18n.noThresholds}</h5></Card>
                                </Grid2>
                            )
                        }
                        <ListThresholds
                            thresholds={orderedThresholds}
                            setThresholds={setThresholds}
                            qualityThresholds={qualityThresholds}
                            setQualityThresholds={setQualityThresholds}
                            isEditMode={isEditMode}
                        />
                    </Grid2>
                )
            }
            <StepperThreshold
                isOpen={isOpen}
                onClose={close}
                onSave={(threshold, qualityThreshold) => {
                    const newId = (maxBy(thresholds, 'code')?.code ?? 0) + 1
                    const newThreshold = { ...threshold, code: newId }
                    const newQualityThreshold = { ...qualityThreshold, thresholdCode: newId, thresholdType: threshold.thresholdType }
                    setThresholds(prev => [...prev, newThreshold])
                    setQualityThresholds(prev => [...prev, newQualityThreshold])
                    close()
                }}
                selectedThreshold={{ thresholdType: '0', users: [], administrators: [] }}
                selectedQualityThreshold={{ thresholds: [] }}
            />
            <PopinImportThresholds
                isOpen={isImportOpen}
                close={closeImport}
                newId={(maxBy(thresholds, 'code')?.code ?? 0) + 1}
                onValidate={(newThresholds, newQualityThresholds) => {
                    setThresholds(prev => [...prev, ...newThresholds])
                    setQualityThresholds(prev => [...prev, ...newQualityThresholds])
                    closeImport()
                }}
            />
        </div>
    )
}

export default QualityThresholdApp
